module.exports = __webpack_public_path__ + "static/james-lamp-zoom-7c79f31412e124eb24c3484048a113c1.jpg";